import type { UserSelectorState } from '@peloton/auth/redux';
import { getSignedInUsername } from '@peloton/auth/redux';
import type { FetcherSelectorState } from '@peloton/redux-fetch/redux';
import type { ClassDetailSelectorState } from '@engage/class-detail/selectors';
import { isLive } from '@engage/classes/models';
import type { ClassSelectorState } from '@engage/classes/redux';
import { getClassAnalyticsProperties } from '@engage/classes/selectors';
import type { VideoSelectorState } from '@engage/video/redux';
import { getSeekTime, getStartTime } from '@engage/video/redux';
import { getClassId } from '@engage/video/selectors';
import type { WorkoutSelectorState } from '@engage/workouts/redux';
import type { FeatureToggleState } from '@members/feature-toggles/redux';
import { maybeClass } from './shared';

type VideoAnalyticsPropertiesState = VideoSelectorState &
  ClassSelectorState &
  FetcherSelectorState &
  WorkoutSelectorState;

export type VideoStateAnalyticsProperties = {
  currentTimecode: number;
  sessionStart: number;
  timePlaying: number;
  introTimePlaying: number;
  timeCasting: number;
  timeWithCaptions: number;
  timeWithAudio: number;
};

export type PersistedVideoProperties = {
  persistedTimecode: number;
  persistedStart: number;
};

export const getRefreshVideoAnalytics = (
  state: VideoSelectorState,
): PersistedVideoProperties => ({
  persistedTimecode: getSeekTime(state) ?? 0,
  persistedStart: getStartTime(state) ?? 0,
});

export const getAllRefreshAnalytics = (
  state: VideoAnalyticsPropertiesState & ClassDetailSelectorState & FeatureToggleState,
) => {
  const classId = getClassId(state) ?? '';

  return {
    classInfo: getClassAnalyticsProperties(state, classId),
    timeInfo: getRefreshVideoAnalytics(state),
  };
};

export const getPropertiesForYoubora = (
  state: Parameters<typeof maybeClass>[0] & UserSelectorState,
) => {
  const klass = maybeClass(state);
  return {
    username: getSignedInUsername(state),
    ...(klass
      ? {
          classId: klass.id,
          isLive: isLive(klass),
        }
      : {}),
  };
};
